import React, { useEffect } from 'react';
import Immutable, { Map } from 'immutable';
import { CoreLink, Menu } from '@uncinc/react-drupal-core';
import { useDispatch, useSelector } from 'react-redux';
import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';
import c from 'classnames';
import { hideMobileMenu } from '../../../actions/UI';

import './style.scss';

const NavigationMainMenu = ({ path }) => {
  const dispatch = useDispatch();

  const eventEntities = useSelector(
    (state) => state.getIn(['view', 'events', 'block_2', 'entities'], Immutable.List()),
  ) || Immutable.List();

  useEffect(() => {
    if (eventEntities.size === 0) {
      dispatch(viewGet('events', 'block_2', 0));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="NavigationMainMenu">
      <Menu id="main">
        {(items) => {
          return (
            <ul className="menu">
              {items.map((item) => {
                const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
                const href = item.getIn(['link', 'url'], '');
                const title = item.getIn(['link', 'title'], 'Untitled');
                const eventsLink = title === 'Events';

                return (
                  <li
                    key={`menu--main--menu-item-${title}:${href}`}
                    className={c('NavigationMainMenu__item menu-item', {
                      'menu-item--active': item.getIn(['link', 'url']) === path,
                    })}
                  >
                    <CoreLink
                      to={href}
                      target={attrs.get('target')}
                      onClick={() => { dispatch(hideMobileMenu()); }}
                    >
                      {title}
                      {(eventsLink && eventEntities.size > 1) && (
                        <div className="counter">{eventEntities.size}</div>
                      )}
                    </CoreLink>
                  </li>
                );

              })}
            </ul>
          );
        }}
      </Menu>
    </div>
  );
};

export default NavigationMainMenu;
